import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import * as db from '../services/db'
import type { Receipt as ReceiptType } from '../types'

export function ReceiptView() {
  const { id } = useParams<{ id: string }>()
  const [receipt, setReceipt] = useState<ReceiptType | null>(null)
  const [products, setProducts] = useState<Map<string, { name: string; imagePath: string }>>(new Map())

  useEffect(() => {
    if (!id) return
    const run = async () => {
      const all = await db.getAllReceipts()
      const r = all.find((x) => x.id === id) ?? null
      setReceipt(r)
      if (r) {
        const allProducts = await db.getAllProducts()
        setProducts(new Map(allProducts.map((p) => [p.id, { name: p.name, imagePath: p.imagePath }])))
      }
    }
    run()
  }, [id])

  if (!receipt) {
    return (
      <div className="page">
        <div className="empty-state">
          <span className="empty-state-emoji" aria-hidden>🧾</span>
          <h2 className="empty-state-title">Receipt not found</h2>
          <Link to="/grocery" className="btn-large btn-primary" style={{ textDecoration: 'none' }}>Home</Link>
        </div>
      </div>
    )
  }

  const date = new Date(receipt.timestamp).toLocaleString()

  return (
    <div className="page animate-slide-up">
      <h1 className="page-title">Thank you! 🎉</h1>
      <div className="receipt-paper animate-pop">
        <p className="receipt-store">Town Square</p>
        <p className="receipt-date">{date}</p>
        {receipt.items.map((item) => {
          const p = products.get(item.productId)
          return (
            <div key={item.productId} className="receipt-line">
              <span><span style={{ marginRight: 8 }}>{p?.imagePath ?? '📦'}</span>{p?.name ?? 'Item'} × {item.quantity}</span>
              <span>${item.subtotal.toFixed(2)}</span>
            </div>
          )
        })}
        <div className="receipt-total-row">
          <span>Total</span>
          <span>${receipt.total.toFixed(2)}</span>
        </div>
        <p className="receipt-payment-type">Paid with {receipt.paymentType}</p>
      </div>
      <Link to="/grocery" className="btn-large btn-primary" style={{ textDecoration: 'none' }}>
        Done
      </Link>
    </div>
  )
}
